import { BottomSheetTabsListItemProps } from '@/components/molecules/bottom-sheet/bottom-sheet-tabs/bottom-sheet-tabs-list';
import Dropdown from '@/components/molecules/dropdown';
import theme from '@/styles/theme';
import { Nullable } from '@/types/common';
import { QnaCategoryTag } from '@/types/qna';
import { Dispatch } from 'react';
import styled from 'styled-components';

export interface QnaWriteCategoryProps {
  selectedTags: Array<string>;
  onChangeSelectedTags: Dispatch<Array<string>>;
  showCategoriesBottomSheet: boolean;
  selectedCategoriesBottomSheetTabItem: Nullable<BottomSheetTabsListItemProps>;
  toggleCategoriesBottomSheet: (value: boolean) => void;
}

const QnaWriteCategory = ({
  selectedTags,
  onChangeSelectedTags,
  selectedCategoriesBottomSheetTabItem,
  showCategoriesBottomSheet,
  toggleCategoriesBottomSheet,
}: QnaWriteCategoryProps) => {
  const onSelectTagItem = (tag: QnaCategoryTag) => {
    const tagIndex = selectedTags.findIndex((name) => name === tag.name);
    const list = [...selectedTags];
    if (tagIndex < 0) {
      list.push(tag.name);
    } else {
      list.splice(tagIndex, 1);
    }
    onChangeSelectedTags(list);
  };

  const isSelectedTag = (tag: QnaCategoryTag) => {
    return selectedTags.includes(tag.name);
  };

  return (
    <QuickAnswerCategoryWrapper>
      <Dropdown
        id='quickAnswerCategory'
        label='카테고리'
        labelSpacing='12px'
        placeholder={selectedCategoriesBottomSheetTabItem?.title || '증상•과목 선택'}
        placeHolderColor={theme.color.gray600}
        isOpened={showCategoriesBottomSheet}
        onClickTrigger={() => toggleCategoriesBottomSheet(true)}
      />
      <QuickAnswerTagsWrapper>
        {selectedCategoriesBottomSheetTabItem?.tags.map((tag) => (
          <Tag key={tag.name} selected={isSelectedTag(tag)} onClick={() => onSelectTagItem(tag)}>
            {tag.name}
          </Tag>
        ))}
      </QuickAnswerTagsWrapper>
    </QuickAnswerCategoryWrapper>
  );
};

export default QnaWriteCategory;

const QuickAnswerCategoryWrapper = styled.div``;

const QuickAnswerTagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  gap: 8px;
`;

const Tag = styled.span<{ selected: boolean }>`
  padding: 6px 12px;
  border-radius: 40px;
  cursor: pointer;

  ${({ theme, selected }) => `
    ${theme.typography.UI14SB};
    color: ${selected ? '#f76707' : theme.color.gray600};
    background: ${theme.color.white};
    border: 1px solid ${selected ? '#fd7e14' : theme.color.gray200};
  `};
`;
